import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

interface ApiResponse {
  status: boolean,
  data: any,
  message: string
}

@Injectable({
  providedIn: 'root'
})
export class ReadingJsonService {

  private _jsonUrl = 'assets/onboarding-data.json';

  constructor(private http: HttpClient) { }

  public getData(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this._jsonUrl);
  }
}
